// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"2822c89a","94":"d7b277b2","285":"4115e1e2","417":"72098c62","419":"04ec4296","458":"e78440e7","774":"31304f54","787":"938d8cca","858":"27cbe00f","942":"28e295d7","979":"9f1fc5f3"}[chunkId] + ".chunk.js";
};